// Allowlist mapping value-prop icon keys (stored in portal_settings) to MUI
// icon components. Mirrors the DB-driven product icon_key pattern: settings can
// only choose from this curated set, and an unknown key falls back to a safe
// default rather than rendering raw text or breaking the build.
import SavingsIcon from '@mui/icons-material/Savings';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CloudIcon from '@mui/icons-material/Cloud';
import GroupsIcon from '@mui/icons-material/Groups';
import StarIcon from '@mui/icons-material/Star';
import PublicIcon from '@mui/icons-material/Public';
import MapIcon from '@mui/icons-material/Map';
import InsightsIcon from '@mui/icons-material/Insights';

const ICONS = {
  savings: SavingsIcon,
  verified_user: VerifiedUserIcon,
  cloud: CloudIcon,
  groups: GroupsIcon,
  star: StarIcon,
  public: PublicIcon,
  map: MapIcon,
  insights: InsightsIcon,
};

const FALLBACK_ICON = StarIcon;

export const resolveValuePropIcon = (key) => ICONS[key] || FALLBACK_ICON;

export const VALUE_PROP_ICON_KEYS = Object.keys(ICONS);
